var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnemicButton',{staticClass:"pa-0 save-button",attrs:{"loading":_vm.loading,"tile":""},on:{"click":function($event){$event.stopPropagation();return _vm.saveIdea.apply(null, arguments)}}},[_c('SIcon',{staticClass:"mr-2",attrs:{"height":"14","width":"12","name":"save-idea"}}),_vm._v(" Save idea ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }